module.exports = __webpack_public_path__ + "img/bg6-4.dbc260d0.png";